import OptimizedImage from './view';
export default OptimizedImage;
